import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Button, Modal, Message } from '@weezevent/nacre';

export default function DeactivationModal({ waitingList = null, onSubmit, isLoading, onClose }) {
    const { t } = useTranslation();

    if (!waitingList) {
        return null;
    }

    return (
        <Modal
            allowExternalClosing={false}
            open={Boolean(waitingList)}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.common.action.confirm')} onClick={onSubmit} isLoading={isLoading} />}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} disabled={isLoading} />}
            title={t('ticket.waiting_list.deactivation_modal.title')}
        >
            <div style={{ marginTop: '15px' }}>
                <Message type="warning" title={t('ticket.waiting_list.deactivation_modal.message-title')}>
                    {t('ticket.waiting_list.deactivation_modal.description')}
                </Message>
            </div>
        </Modal>
    );
}

DeactivationModal.propTypes = {
    waitingList: PropTypes.object,
    onClose: PropTypes.func.isRequired
};
